/**
 * The front page.
 *
 * One scroll, in the order a stranger evaluates a studio: what you do, proof
 * you can do it, how the work runs, what is guaranteed, what you run it on,
 * who you actually are, what it costs, why to move now, and then the form.
 *
 * The proof comes second on purpose. Everything after it is easier to believe
 * once somebody has seen three real products with live sites attached.
 */
import { Seo } from '../components/Seo';
import { StructuredData } from '../components/StructuredData';
import { Hero } from '../sections/Hero';
import { Services } from '../sections/Services';
import { Products } from '../sections/Products';
import { Method } from '../sections/Method';
import { Standards } from '../sections/Standards';
import { Stack } from '../sections/Stack';
import { Studio } from '../sections/Studio';
import { Engagements } from '../sections/Engagements';
import { Offer } from '../sections/Offer';
import { Proposal } from '../sections/Proposal';

export default function HomePage() {
  return (
    <>
      <Seo path="/" />
      <StructuredData />

      <Hero />
      <Services />
      <Products />
      <Method />
      <Standards />
      <Stack />
      <Studio />
      <Engagements />
      <Offer />
      <Proposal />
    </>
  );
}
